// Paths of the Secure AI Adoption pages. Content files link through these
// constants so a URL only ever changes here (and in src/router/securityRoutes.js).
export const ROUTES = {
  home: '/',
  about: '/about',
  services: '/services',
  assessment: '/assessment',
  score: '/score',
  roadmap: '/maturity-roadmap',
  baseline: '/security-baseline',
  // The artifact's contact page is a reference stub; the existing contact page is used unchanged.
  contact: '/contact',
  // "For Job Seekers" goes to the existing Join our Talent Pool page (legacy route, unchanged).
  careers: '/talents-on-demand',
};

export const CLAUDE_PARTNERS_URL = 'https://claude.com/partners';

// Same booking link the legacy "Schedule a Meeting" buttons use (.env).
export const CALENDLY_URL = process.env.VUE_APP_CALENDLY_LINK;
